import React from "react";
import { cn } from "@/lib/utils";

const Arrow = ({ arrowType, fill }: { arrowType?: string; fill?: string }) => {
  return (
    <svg
      className={cn("", arrowType === "next" ? "rotate-180" : "")}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.4564 40.1679L31.6651 35.3765L36.4564 30.5852M1.00049 33.9391C1.00049 15.6805 15.8021 0.878905 34.0607 0.878906C52.3194 0.878908 67.121 15.6805 67.121 33.9392C67.121 52.1978 52.3194 66.9994 34.0607 66.9994C15.8021 66.9994 1.00049 52.1978 1.00049 33.9391Z"
        stroke={fill}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Arrow;
